export default {"src":"/_next/static/media/tau.5569f943.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};